import { render, staticRenderFns } from "./customer_transfer_former.vue?vue&type=template&id=13f6fa9c&"
import script from "./customer_transfer_former.vue?vue&type=script&lang=js&"
export * from "./customer_transfer_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports